import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "build",
  "use": "build-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"build\"><title>build</title><g id=\"build_mask-2\"><path id=\"build_path-1\" d=\"M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,8.92,7.56,6.47A.77.77,0,0,0,6.47,7.56L8.92,10,6.47,12.44a.77.77,0,0,0,1.08,1.08L10,11.08l2.44,2.44a.77.77,0,0,0,1.08-1.08L11.08,10l2.44-2.44a.77.77,0,0,0-1.08-1.08Z\" /></g><g id=\"build_Symbols\"><g id=\"build_atoms_icons_small_close-filled\" data-name=\"atoms/icons/small/close-filled\"><g id=\"build_Combined-Shape\"><path id=\"build_path-1-2\" data-name=\"path-1\" d=\"M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,8.92,7.56,6.47A.77.77,0,0,0,6.47,7.56L8.92,10,6.47,12.44a.77.77,0,0,0,1.08,1.08L10,11.08l2.44,2.44a.77.77,0,0,0,1.08-1.08L11.08,10l2.44-2.44a.77.77,0,0,0-1.08-1.08Z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/build.svg
// module id = WmWN
// module chunks = 268